import React, { useState } from "react";
import "./dashboard.css";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import TimeZoneHandler from "../../../handlers/TimeZoneHandler.js";
import config from "../../../helper/config.js";
import { customerConstants } from "../../../helper/constants.js";
import Popover from "@mui/material/Popover";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let iconColor;
const customer = getCustomerFeatureFlag();
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    iconColor = "var(--maincolor)";
    break;
  case customerConstants.EXO_CUSTOMER2:
    iconColor = "var(--maincolor-cmc)";
    break;
  default:
    iconColor = "var(--maincolor)";
    break;
}

const AnnouncementCard = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const formattedDateString = (value) => {
    const dateObject = value ? new Date(value) : undefined;
    const year = dateObject && dateObject.getFullYear();
    const month =
      dateObject && ("0" + (dateObject.getMonth() + 1)).slice(-2); // Adding 1 because getMonth() returns zero-based index
    const day = dateObject && ("0" + dateObject.getDate()).slice(-2);
    const fromattedString = `${day}-${month}-${year}`;
    return fromattedString;
  };

  const formattedTimeString = (value) => {
    const time = new Date(value);
    const formattedTime = time.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
    return formattedTime;
  };
  function convertUTCtoIST(utcDateString) {
    // Parse the UTC date string
    const utcTime = new Date(utcDateString);

    // Convert to IST (Indian Standard Time, UTC+5:30)
    const istOffset = 5.5 * 60 * 60 * 1000; // 5.5 hours in milliseconds
    const istTime = new Date(utcTime.getTime() + istOffset);

    // Format the date for display
    const options = {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      timeZone: "Asia/Kolkata",
    };

    const istTimeString = istTime.toLocaleString("en-US", options);

    return istTimeString;
  }

  function formatTimeDifference(dateString) {
    const currentDate = new Date();
    const providedDate = new Date(
      TimeZoneHandler.convertTimeByUserLocation(dateString)
    );

    const timeDifferenceInMilliseconds = currentDate - providedDate;
    const secondsDifference = Math.floor(timeDifferenceInMilliseconds / 1000);
    const minutesDifference = Math.floor(secondsDifference / 60);
    const hoursDifference = Math.floor(minutesDifference / 60);
    const daysDifference = Math.floor(hoursDifference / 24);
    const weeksDifference = Math.floor(daysDifference / 7);
    const monthsDifference = Math.floor(daysDifference / 30);
    const yearsDifference = Math.floor(daysDifference / 365);

    if (yearsDifference > 0) {
      return `${yearsDifference} ${yearsDifference === 1 ? "year" : "years"
        } ago`;
    } else if (monthsDifference > 0) {
      return `${monthsDifference} ${monthsDifference === 1 ? "month" : "months"
        } ago`;
    } else if (weeksDifference > 0) {
      return `${weeksDifference} ${weeksDifference === 1 ? "week" : "weeks"
        } ago`;
    } else if (daysDifference > 0) {
      return `${daysDifference} ${daysDifference === 1 ? "day" : "days"} ago`;
    } else if (hoursDifference > 0) {
      return `${hoursDifference} ${hoursDifference === 1 ? "hour" : "hours"
        } ago`;
    } else if (minutesDifference > 0) {
      return `${minutesDifference} ${minutesDifference === 1 ? "minute" : "minutes"
        } ago`;
    } else {
      return "Just now";
    }
  }

  return (
    <div className="row announcement__card px-0">
      <div className="px-0 w-100">
        <h3 className="announcement__title m-0">
          {props.announcement.announcement_title}
          {/* Announcement Title */}
        </h3>
        <div className="d-flex justify-content-between align-items-center w-100">
          <span
            className="stu-variant-class label label-lg label-light-success label-inline announcement__breadcrumb"
            aria-owns={open ? "mouse-over-popover" : undefined}
            aria-haspopup="true"
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
          >
            {props.announcement.breadcrumb + props.announcement.title}
          </span>
        </div>
        <Popover
          id="mouse-over-popover"
          sx={{
            pointerEvents: "none",
            padding: '8px 16px'
          }}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus
        >
          <div style={{ padding: "8px 16px" }}>
            {props.announcement.breadcrumb + props.announcement.title}
          </div>
        </Popover>
        <div className="d-flex justify-content-between pt-2 announcement__content">
          <p>
            {/* Posted By:{" "} */}
            <b>
              {/* Person:  */}
              {props.announcement?.create_user_table_id === "1" && "Admin"}
              {props.announcement?.create_user_table_id === "3" && "Parent"}
              {props.announcement?.create_user_table_id === "10" && "Teacher"}
            </b>
          </p>
          &nbsp;
          {/* {`${formatTimeDifference(props.paper?.created_at)} Time zone (IST)`} */}
          <div>
            {formattedDateString(
              TimeZoneHandler.convertTime(props.announcement?.created_at)
            )}{" "}
            &nbsp; &nbsp;{" "}
            {formattedTimeString(
              TimeZoneHandler.convertTime(props.announcement?.created_at)
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementCard;